import { type MatrixClient } from "matrix-js-sdk/src/matrix";

import { shouldForceDisableEncryption } from "./crypto/shouldForceDisableEncryption";
import { getE2EEWellKnown } from "./WellKnownUtils";
import SdkConfig from "../SdkConfig";

export function privateShouldBeEncrypted(client: MatrixClient): boolean {
    if (shouldForceDisableEncryption(client)) {
        return false;
    }
    // se disable_e2ee è esplicitamente false in config.json, forza la cifratura
    // senza controllare il default del .well-known del server
    const configDisableE2EE = SdkConfig.get().disable_e2ee;
    if (configDisableE2EE === false) {
        return true;
    }
    const e2eeWellKnown = getE2EEWellKnown(client);
    if (e2eeWellKnown) {
        const defaultDisabled = e2eeWellKnown["default"] === false;
        return !defaultDisabled;
    }
    return true;
}
